import React from 'react';
import './TrajectoireSketch.css';

/* TrajectoireSketch — « la trajectoire se trace » (proto Olivier, variante 1,
   2026-09-02). La courbe se dessine, les points s'allument dans l'ordre, le
   dernier en vert avec son horizon : un récit chiffré, sans pictogramme
   vidéo. Décoratif, non lié aux données (décision : pas de binding). Boucle
   de 6 s, coupée par prefers-reduced-motion (état final statique). */
export default function TrajectoireSketch() {
  return (
    <span className="tjs" aria-hidden="true">
      <svg viewBox="0 0 200 140">
        <line className="tjs__grid" x1="8" y1="118" x2="196" y2="118" />
        <line className="tjs__grid" x1="8" y1="78" x2="196" y2="78" />
        <line className="tjs__grid" x1="8" y1="38" x2="196" y2="38" />
        <path className="tjs__area" d="M12 104 C 45 100, 62 62, 92 74 S 140 34, 188 26 L188 118 L12 118 Z" />
        <path className="tjs__line" pathLength="1" d="M12 104 C 45 100, 62 62, 92 74 S 140 34, 188 26" />
        <circle className="tjs__dot tjs__d1" cx="12" cy="104" r="4" />
        <circle className="tjs__dot tjs__d2" cx="92" cy="74" r="4" />
        <circle className="tjs__dot tjs__d3" cx="188" cy="26" r="4.5" />
        <text className="tjs__lbl" x="170" y="14">2030</text>
      </svg>
    </span>
  );
}
